// extracted by mini-css-extract-plugin
export var content = "loading-overlay-module--content--73008";
export var inner = "loading-overlay-module--inner--133b4";
export var loadingOverlay = "loading-overlay-module--loading-overlay--5fa96";
export var spin = "loading-overlay-module--spin--a4475";
export var spinner = "loading-overlay-module--spinner--8c9b7";